import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, FormGroup } from "reactstrap";
import FieldWrapper from "../commons/FieldWrapper";
import { saveWorkflow } from "./Axios";

const WorkflowForm = ({ buttonText, reloadWorkflows, showNotification, workflow }) => {
  const [modal, setModal] = useState(false);
  const [name, setName] = useState(workflow?.name || "");

  useEffect(() => {
    if (workflow) setName(workflow.name);
  }, [workflow]);

  const toggle = () => setModal(!modal);

  const handleSubmit = async () => {
    try {
      await saveWorkflow(workflow, { name });
      showNotification("Éxito", "Workflow guardado correctamente", "success");
      reloadWorkflows();
      toggle();
    } catch {
      showNotification("Error", "Hubo un problema al guardar el Workflow", "danger");
    }
  };

  return (
    <>
      <Button color="primary" onClick={toggle}>{buttonText}</Button>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{buttonText}</ModalHeader>
        <ModalBody>
          <FormGroup>
            <Label for="name">Nombre del Workflow</Label>
            <FieldWrapper>
              <Input type="text" value={name} onChange={(e) => setName(e.target.value)} />
            </FieldWrapper>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleSubmit}>Guardar</Button>
          <Button color="danger" onClick={toggle}>Cancelar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default WorkflowForm;
